<div class="ml-5">
  @if (showMenu) {
    <div class="container mx-auto">
      <p class="titre1 m-4">
        {{ 'CONTENUS_MANAGEMENT.PAGE_CONTENUS_MANAGEMENT' | translate }}
        <mat-icon class="material-symbols-outlined text-[38px] w-[45px] h-[45px] mt-[5px] mr-[30px] float-right">monitoring</mat-icon>
      </p>
      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        <app-managment-card [title]="'RAPPORT.RAPPORT_FORMATION' | translate" [textColor]="'text-white'"
          [bgColor]="'bg-blueCielNovo'" [icon]="'monitoring'" [routerLink]="'/rapports/formations/complete'">
        </app-managment-card>
        <app-managment-card [title]="'RAPPORT.RAPPORT_PARCOURS' | translate" [textColor]="'text-white'"
          [bgColor]="'bg-moveFonceNovo'" [icon]="'conversion_path'" [routerLink]="'/rapports/parcours-formation'">
        </app-managment-card>
      </div>
    </div>
  }

  @if (!showMenu) {
    <div class="mx-auto">
      <button type="button" (click)="goBack()" class="btn-secondary-novo mb-4 ml-4">
        {{ 'INDEX_FORMATION.RETOUR' | translate }}
      </button>
      <router-outlet></router-outlet>
    </div>
  }
</div>
